export default function Healthcare({ fill }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9241 3.97402C18.059 5.16105 18.5084 6.79351 18.2725 8.33332H16.5768C16.8313 7.21758 16.5455 5.98976 15.7195 5.12578C14.4968 3.84699 12.547 3.84699 11.3243 5.12578L10.0001 6.5109L8.67578 5.12574C7.45317 3.84695 5.50328 3.84695 4.28066 5.12574C3.45461 5.98976 3.16883 7.21758 3.42332 8.33332H1.7277C1.49168 6.79351 1.94113 5.16101 3.07598 3.97398C4.81938 2.15054 7.56781 2.0189 9.45625 3.57918C9.60523 3.7024 9.74688 3.83423 9.88047 3.97398L10.0001 4.0991L10.1196 3.97402C10.2553 3.83219 10.397 3.70058 10.5439 3.57918C12.4323 2.0189 15.1807 2.15051 16.9241 3.97402ZM14.068 11.6667H16.3739L10.0001 18.3333L3.62625 11.6667H5.93207L10.0001 15.9216L14.068 11.6667ZM7.50008 4.80328L5.31758 9.16668H1.66676V10.8333H6.34844L7.50008 8.53L10.0001 13.53L11.3484 10.8333H18.3334V9.16668H12.1818L11.2501 7.30328L10.0001 9.8025L7.50008 4.80328Z"
        fill={fill}
      />
    </svg>
  );
}
